import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {Renderer} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {SchedulingLinkWarningText} from '../schedulingLinkWarningText';

/*
 * Props.
 */

interface SchedulingLinkDetailRowProps {
  label: ReactNode;
  renderTooltip?: Renderer;
  renderWarning?: Renderer;
  children: ReactNode;
}

/*
 * Style.
 */

const StyledRowDiv = styled.div`
  display: grid;
  grid-row-gap: 6px;
`;

const StyledLabelWrapperDiv = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-column-gap: 5px;
`;

const StyledLabel = styled.label`
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  color: ${(p) => p.theme.greys.shade70};
`;

/*
 * Component.
 */

export const SchedulingLinkDetailRow: FC<PropsWithChildren<SchedulingLinkDetailRowProps>> = (props) => (
  <StyledRowDiv>
    {renderLabel(props)}
    <div>{props.children}</div>
    {maybeRenderWarning(props)}
  </StyledRowDiv>
);

function renderLabel(props: SchedulingLinkDetailRowProps) {
  return (
    <StyledLabelWrapperDiv>
      <StyledLabel>{props.label}</StyledLabel>
      {props.renderTooltip && (
        <TooltipCoordinator render={props.renderTooltip} placement="top" maxWidth={240} delay={0} />
      )}
    </StyledLabelWrapperDiv>
  );
}

function maybeRenderWarning(props: SchedulingLinkDetailRowProps) {
  if (!props.renderWarning) {
    return null;
  }

  return <SchedulingLinkWarningText>{props.renderWarning()}</SchedulingLinkWarningText>;
}
